export class OnboardingApplication {

    private id!: number;
    private fullNameNric!: string;
    private preferredName!: string;
    private branch!: string;
    private finacialServiceDir!: string;
    private finacialServiceMan!: string;
    private designation!: string;
    private personalEmailAddres!: string;
    private nameOfReferal!: string;
    private remarkId!: number;
    private remarkContent!: string;
    private updatedByRole!: string;
    private piasRepCode!: string;
    private companyName!: string;

    constructor() { }

    // Getters & Setters

    getId(): number {
        return this.id;
    }
    setId(id: number) {
        this.id = id;
    }

    getremarkId(): number {
        return this.remarkId;
    }
    setremarkId(remarkId: number) {
        this.remarkId = remarkId;
    }

    getFullNameNric(): string {
        return this.fullNameNric;
    }

    setFullNameNric(fullNameNric: string) {
        this.fullNameNric = fullNameNric;
    }

    getPreferredName(): string {
        return this.preferredName;
    }

    setPreferredName(preferredName: string) {
        this.preferredName = preferredName;
    }

    getBranch(): string {
        return this.branch;
    }

    setBranch(branch: string) {
        this.branch = branch;
    }

    getFinacialServiceDir(): string {
        return this.finacialServiceDir;
    }

    setFinacialServiceDir(finacialServiceDir: string) {
        this.finacialServiceDir = finacialServiceDir;
    }

    getFinacialServiceMan(): string {
        return this.finacialServiceMan;
    }

    setFinacialServiceMan(finacialServiceMan: string) {
        this.finacialServiceMan = finacialServiceMan;
    }

    getDesignation(): string {
        return this.designation;
    }

    setDesignation(designation: string) {
        this.designation = designation;
    }

    getPersonalEmailAddres(): string {
        return this.personalEmailAddres;
    }

    setPersonalEmailAddres(personalEmailAddres: string) {
        this.personalEmailAddres = personalEmailAddres;
    }

    getRemarkContent(): string {
        return this.remarkContent;
    }

    setRemarkContent(remarkContent: string) {
        this.remarkContent = remarkContent;
    }

    getUpdatedByRole(): string {
        return this.updatedByRole;
    }

    setUpdatedByRole(updatedByRole: string) {
        this.updatedByRole = updatedByRole;
    }

    getNameOfReferal(): string {
        return this.nameOfReferal;
    }

    setNameOfReferal(nameOfReferal: string) {
        this.nameOfReferal = nameOfReferal;
    }

    getCompanyName(): string {
        return this.companyName;
    }

    setCompanyName(companyName: string) {
        this.companyName = companyName;
    }

    getPiasRepCode(): string {
        return this.piasRepCode;
    }

    setPiasRepCode(piasRepCode: string) {
        this.piasRepCode = piasRepCode;
    }




    toString() {
        return JSON.stringify({
            fullNameNric: this.getFullNameNric(),
            company_name:this.getCompanyName(),
            preferredName: this.getPreferredName(),
            branch: this.getBranch(),
            finacialServiceDir: this.getFinacialServiceDir(),
            finacialServiceMan: this.getFinacialServiceMan(),
            designation: this.getDesignation(),
            personalEmailAddres: this.getPersonalEmailAddres(),
            nameOfReferal: this.getNameOfReferal(),
            remarkContent: this.getRemarkContent(),
            updatedByRole: this.getUpdatedByRole(),
            piasRepCode: this.getPiasRepCode()
        });
    }

    edittoString() {
        return JSON.stringify({
            id: this.getId(),
            fullNameNric: this.getFullNameNric(),
            company_name:this.getCompanyName(),
            preferredName: this.getPreferredName(),
            branch: this.getBranch(),
            finacialServiceDir: this.getFinacialServiceDir(),
            finacialServiceMan: this.getFinacialServiceMan(),
            designation: this.getDesignation(),
            personalEmailAddres: this.getPersonalEmailAddres(),
            nameOfReferal: this.getNameOfReferal(),
            remarkId: this.getremarkId(),
            remarkContent: this.getRemarkContent(),
            updatedByRole: this.getUpdatedByRole(),
            piasRepCode: this.getPiasRepCode()
        });
    }

}
